import { render } from "./policyViewModal.vue?vue&type=template&id=2d9cf24a&scoped=true"
import script from "./policyViewModal.vue?vue&type=script&lang=js"
export * from "./policyViewModal.vue?vue&type=script&lang=js"

import "./policyViewModal.vue?vue&type=style&index=0&id=2d9cf24a&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9cf24a"]])

export default __exports__